// extracted by mini-css-extract-plugin
module.exports = {"container":"artist-block_container_2hk1Y","inner":"artist-block_inner_1FBvm"};